export const HTTP_STATUS_CODE_BAD_REQUEST = 400;
export const HTTP_STATUS_CODE_UNAUTHORIZED = 401;
export const HTTP_STATUS_CODE_FORBIDDEN = 403;
export const HTTP_STATUS_CODE_NOT_FOUND = 404;
export const HTTP_STATUS_CODE_TOO_EARLY = 425;

export const CSRF_HEADER = 'x-csrf-token';
export const LocationPrincipalDomain = 'Location';
export const NeighborPrincipalDomain = 'Neighbor';

export const AXIOS_MAX_RETRIES = 5;

export const vsgModeStatus = {
  INCOMPLETE: 'SETUP_INCOMPLETE',
  NO_DEVICES: 'ENROLLED_DEVICE_NOT_FOUND',
  NO_RING_PROTECT: 'PROFESSIONAL_MONITORING_NOT_ENABLED',
  AUTH_NOT_FOUND: 'AUTH_NOT_FOUND',
  PENDING_MODE: 'PENDING_MODE',
  EVENTS_EXCEEDED: ['EVENT_OVERAGES_THRESHOLD_EXCEEDED', 'EVENT_OVERAGES_CAP_EXCEEDED'],
  SOS_OFF: 'SOS_OFF',
  SOS_SETUP_INCOMPLETE: 'SOS_SETUP_INCOMPLETE',
  MISSING_MONITORING_ZONE: 'MISSING_MONITORING_ZONE',
};

export const accountStatuses = {
  PRACTICE: 'PRACTICE_MODE',
  PENDING: 'PENDING',
  PROFESSIONAL: 'PROFESSIONAL',
  UNSUPPORTED: 'UNSUPPORTED',
  SOS_ON: 'SOS_ON',
  SOS_OFF: 'SOS_OFF',
  SOS_SETUP_INCOMPLETE: 'SOS_SETUP_INCOMPLETE',
  SOS_NOT_AVAILABLE: 'SOS_NOT_AVAILABLE',
};

export const freeTrialStatus = {
  ACTIVE: 'ACTIVE',
  AVAILABLE: 'AVAILABLE',
  UNAVAILABLE: 'UNAVAILABLE',
};

export const armedStatus = {
  INACTIVE: 'INACTIVE',
  ACTIVE: 'ACTIVE',
};

export const guardPatrolState = {
  ACTIVE: 'active',
  UNAVAILABLE: 'unavailable',
  SETUP_INCOMPLETE: 'setupIncomplete',
};
